import React, { Component, createRef } from 'react'
import { injectIntl } from 'react-intl'
import {
  Typography,
  Paper,
  MenuList,
  Collapse,
  ClickAwayListener,
} from '@material-ui/core'
import SvgIcon from '@material-ui/core/SvgIcon'
import MenuItem from 'components/override/MaterialUI/MenuItem'
import ArrayHelper from 'helpers/array'
import { TABLET_BREAKPOINT } from 'helpers/responsive'
import { ReactComponent as Assign } from 'assets/img/ic_assign.svg'
import SidePopover from 'components/common/Popover/SidePopover'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import messages from '../translate'

class AssignAll extends Component {
  constructor(props) {
    super(props)

    this.state = {
      openOptions: !!props.openOptions,
      isOpen: false,
      ...this.initStateData(props),
    }

    this.assignChipRef = createRef()
  }

  shouldComponentUpdate(nextProps) {
    const { groups, users } = this.props
    const { groups: nextGroups, users: nextUsers } = nextProps

    if (groups !== nextGroups || users !== nextUsers) {
      this.setState(this.initStateData(nextProps))

      return false
    }

    return true
  }

  onClickAssignChipOutside = ({ target: { classList } }) => {
    const shouldClose = ![...classList].includes('assign-target')

    if (shouldClose) {
      this.setState({ isOpen: false })
    }
  }

  initStateData = props => {
    const {
      groups,
      users,
      intl: { formatMessage },
    } = props
    const indexedGroupsValues = ArrayHelper.map([], 'id')
    const indexedUsersValues = ArrayHelper.map([], 'id')
    const options = []
    const formatValues = (list, initValues, prefix, title) => {
      if (list.size > 0) {
        options.push({
          title,
          key: `${prefix}`,
          isLabel: true,
        })

        list.forEach((item, index) => {
          const data = {
            index,
            prefix,
            selected: false,
            optionIndex: options.length,
            key: `${prefix}_${item.get('id')}`,
            id: item.get('id'),
            name: item.get('name'),
          }

          options.push(data)

          if (Object.prototype.hasOwnProperty.call(initValues, data.id)) {
            data.selected = true
          }
        })
      }
    }

    formatValues(
      groups,
      indexedGroupsValues,
      'group',
      formatMessage(messages.groups),
    )
    formatValues(
      users,
      indexedUsersValues,
      'user',
      formatMessage(messages.users),
    )

    return { options }
  }

  onOpenOptions = () => {
    this.setState({ isOpen: true })
  }

  onChangeOption = event => {
    const { options } = this.state
    const { allSelectedUsers, allSelectedGroups, onChange } = this.props
    const value = options[event.currentTarget.value]
    const all = [...allSelectedUsers, ...allSelectedGroups]
    value.selected = !all.includes(value.id)
    let newUsers = allSelectedUsers
    let newGroups = allSelectedGroups

    if (value.prefix === 'group') {
      newGroups = value.selected
        ? [...newGroups, value.id]
        : newGroups.filter(g => g !== value.id)
    } else {
      newUsers = value.selected
        ? [...newUsers, value.id]
        : newUsers.filter(g => g !== value.id)
    }

    onChange(
      { assigned_users: newUsers, assigned_user_groups: newGroups },
      value,
    )
  }

  render() {
    const { options, isOpen } = this.state
    const {
      taskId,
      activeListId,
      intl: { formatMessage },
      allSelectedUsers,
      allSelectedGroups,
      onClearAll,
    } = this.props
    const isActiveTask = activeListId === taskId
    const all = [...allSelectedUsers, ...allSelectedGroups]

    return (
      <Paper className="mj-chip-list">
        <div className="assign-all-container">
          <div
            className="assign-all assign-target"
            onClick={this.onOpenOptions}>
            <SvgIcon component={Assign} className="assign-target" />
            <Typography className="assign-all-text assign-target">
              {formatMessage(messages.assignToAll)}
            </Typography>
          </div>
          <Typography onClick={onClearAll} className="clear-all-text">
            {formatMessage(messages.clearAll)}
          </Typography>
        </div>
        <div ref={isActiveTask ? this.assignChipRef : null}>
          {ifWindowWidthLessThan(TABLET_BREAKPOINT) ? (
            <SidePopover
              open={isOpen}
              close={this.onClickAssignChipOutside}
              className="extra-menu"
              position="bottom">
              <MenuList className="sidebar-option-list">
                {options.map(({ isLabel, key, title, id, name }, index) =>
                  isLabel ? (
                    <Typography key={key} variant="subtitle1">
                      {title}
                    </Typography>
                  ) : (
                    <MenuItem
                      key={key}
                      value={index}
                      selected={all.includes(id)}
                      onClick={this.onChangeOption}>
                      {name}
                    </MenuItem>
                  ),
                )}
              </MenuList>
            </SidePopover>
          ) : (
            <ClickAwayListener onClickAway={this.onClickAssignChipOutside}>
              <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <MenuList className="sidebar-option-list desktop">
                  {options.map(({ isLabel, key, title, id, name }, index) =>
                    isLabel ? (
                      <Typography key={key} variant="subtitle1">
                        {title}
                      </Typography>
                    ) : (
                      <MenuItem
                        key={key}
                        value={index}
                        selected={all.includes(id)}
                        onClick={this.onChangeOption}>
                        {name}
                      </MenuItem>
                    ),
                  )}
                </MenuList>
              </Collapse>
            </ClickAwayListener>
          )}
        </div>
      </Paper>
    )
  }
}

export default injectIntl(AssignAll)
